/**
 * Vendor Attribution Actions
 */

import Constants from '../../constants';

const { VendorAttribution } = Constants;

/**
 * Action object dispatched to update vendor attributes
 *
 * @param {string} userId the user id
 * @param {object} update the key value pair for updating vendor fields
 */
const createVendorAttributes = (vendorAttributes) => ({
  type: VendorAttribution.CREATE_VENDOR_ATTRIBUTES,
  vendorAttributes,
});

/**
 * Action object dispatched when updating vendor attributes errors
 *
 * @param {object} error error object
 */
const createVendorAttributesError = (error) => ({
  type: VendorAttribution.CREATE_VENDOR_ATTRIBUTES_ERROR,
  error,
});

/**
 * Action object dispatched when updating vendor attributes succeeds
 *
 * @param {object} vendor data object of the vendor to be updated
 */
const createVendorAttributesSuccess = ({ vendorAttributes }) => ({
  type: VendorAttribution.CREATE_VENDOR_ATTRIBUTES_SUCCESS,
  vendorAttributes,
});

/**
 * Action object dispatched to update vendor attributes
 *
 * @param {string} userId the user id
 * @param {object} update the key value pair for updating vendor fields
 */
const updateVendorAttributes = (userId, update) => ({
  type: VendorAttribution.UPDATE_VENDOR_ATTRIBUTES,
  userId,
  update,
});

/**
 * Action object dispatched when updating vendor attributes errors
 *
 * @param {object} error error object
 */
const updateVendorAttributesError = (error) => ({
  type: VendorAttribution.UPDATE_VENDOR_ATTRIBUTES_ERROR,
  error,
});

/**
 * Action object dispatched when updating vendor attributes succeeds
 *
 * @param {object} vendor data object of the vendor to be updated
 */
const updateVendorAttributesSuccess = ({ vendor }) => ({
  type: VendorAttribution.UPDATE_VENDOR_ATTRIBUTES_SUCCESS,
  vendor,
});

export default {
  createVendorAttributes,
  createVendorAttributesError,
  createVendorAttributesSuccess,
  updateVendorAttributes,
  updateVendorAttributesError,
  updateVendorAttributesSuccess,
};
